module.exports = __webpack_public_path__ + "static/1074-86924d7917ff9d68a1254b4bb5bd918e.png";